<template>
  <el-drawer
    custom-class="drawer-custom-class"
    append-to-body
    :close-on-press-escape="false"
    title="仓库管理"
    size="640px"
    :visible.sync="visible"
    direction="rtl"
    @closed="onClosed">
    <div
      v-loading="loading"
      class="drawer-wrap">
      <div class="search-from">
        <el-button
          type="primary"
          @click="editItem({})">新增仓库</el-button>
        <el-input
          v-model="config.warehouseName"
          style="width: 240px"
          clearable=""
          placeholder="请输入仓库名称">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          label="仓库编号"
          width="120"
          prop="warehouseNo"></el-table-column>
        <el-table-column
          label="仓库名称"
          min-width="200"
          prop="warehouseName"></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="150">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="editItem(row)">修改</el-button>
            <el-button
              type="text"
              @click="deleteItem(row)">删除</el-button>
            <el-button
              type="text"
              @click="viewBinSet(row)">库位管理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align: center;"
        :current-page="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </div>

    <warehouse-edit-modal
      ref="warehouse"
      @fetch="fetchList" />

    <binset-modal ref="binset" />
  </el-drawer>
</template>
<script>
import Wms from '@/service/wms'
import WarehouseEditModal from './warehouse-edit-modal.vue'
import BinsetModal from './binset/binset-modal.vue'
export default {
  name: 'WarehouseModal',
  components: { WarehouseEditModal, BinsetModal },
  data() {
    return {
      visible: false,
      loading: false,
      config: { pageNum: 1, pageSize: 10, warehouseName: '' },
      list: [],
      total: 0
    }
  },
  methods: {
    viewBinSet(row) {
      const { warehouseId, warehouseName } = row
      this.$refs.binset.fetch({ warehouseId, warehouseName })
    },
    editItem(row) {
      this.$refs.warehouse.init({ ...row })
    },
    deleteItem(row) {
      this.$confirm('此操作将永久删除该仓库, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Wms.deletewarehouse({ warehouseId: row.warehouseId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    onClosed() {
      this.config = { ...this.config, ...this.$options.data().config }
      this.total = 0
      this.list = []
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Wms.getwarehouses({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if (result === 0) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch() {
      this.fetchList()
      this.visible = true
    }
  }
}
</script>
